import { causeError } from 'libs/types/checkTypes';
import { Type } from '../const';

/**
 * @function updateTab
 * @param { array } menus
 * @param { array } tabs
 * @param { string } groupId
 * @returns { array }
 */
function updateTab(menus, tabs, groupId) {
	const apps = Array.from(menus);

	for (let a = 0; a < apps.length; a++) {
		for (let b = 0; b < apps[a].groups.length; b++) {
			if (groupId === apps[a].groups[b].id) {
				apps[a].groups[b].tabs = [...tabs];
			}
		}
	}
	return apps;
}

/**
 * @function updateSubtab
 * @param { array } menus
 * @param { array } subtabs
 * @param { string } groupId
 * @param { string } tabId
 * @returns { array }
 */
function updateSubtab(menus, subtabs, groupId, tabId) {
	const apps = Array.from(menus);

	for (let a = 0; a < apps.length; a++) {
		for (let b = 0; b < apps[a].groups.length; b++) {
			if (groupId === apps[a].groups[b].id) {
				for (let c = 0; c < apps[a].groups[b].tabs.length; c++) {
					if (tabId === apps[a].groups[b].tabs[c].id) {
						apps[a].groups[b].tabs[c].subtabs = [...subtabs];
					}
				}
			}
		}
	}
	return apps;
}

/**
 * @function updateRole
 * @param { array } menus
 * @param { array } roles
 * @param { string } groupId
 * @returns { array }
 */
function updateRole(menus, roles, groupId) {
	const apps = Array.from(menus);

	for (let a = 0; a < apps.length; a++) {
		for (let b = 0; b < apps[a].groups.length; b++) {
			if (groupId === apps[a].groups[b].id) {
				apps[a].groups[b].roles = [...roles];
			}
		}
	}
	return apps;
}

/**
 * @function updateMenu
 * @param { string } type
 * @param { array} values
 * @param { array } menus
 * @param { string } groupId
 * @param { string || undefined } tabId
 * @returns { array }
 */
function updateMenu(type, values, menus, groupId, tabId) {
	let results = [];

	if (type === Type.Tab) {
		results = updateTab(menus, values, groupId);
	} else if (type === Type.Subtab) {
		results = updateSubtab(menus, values, groupId, tabId);
	} else if (type === Type.Role) {
		results = updateRole(menus, values, groupId);
	} else {
		causeError('Cause error at the updateMenu() method!');
	}

	return results;
}

export default updateMenu;
